import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./ExcursionAccessibilityLevel.module.scss";
import clsx from "clsx";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";
import { useExcursionsMicroContent } from "src/page-components/cruise/ExcursionsMicroContentProvider";

interface ExcursionAccessibilityLevelProps {
  level: string;
  showDescription?: boolean;
  titleClassName?: string;
  size: "small" | "big";
}

const ExcursionAccessibilityLevel: React.FC<
  React.PropsWithChildren<ExcursionAccessibilityLevelProps>
> = ({ level, showDescription = false, titleClassName = undefined, size }) => {
  const { accessibilityLevels = [] } = useExcursionsMicroContent();
  const { icon, label, content } =
    accessibilityLevels.find((x) => x?.code == level) || {};

  // const { fullIcons, label, description } =
  //   levelsDefinitions[level] || unknownLevel;

  return (
    <div
      className={clsx({
        [styles.container]: true,
        [styles.withDescription]: showDescription,
        [styles.sizeBig]: size == "big"
        //[styles.sizeSmall]: size == "small"
      })}
    >
      <div
        className={clsx({
          [styles.title]: true,
          [titleClassName || ""]: titleClassName
        })}
      >
        <Trans>Accessibility</Trans>
      </div>
      <div className={styles.body}>
        {icon && (
          <Icon
            name={icon as IconName}
            className={styles.icon}
            size="1x"
            padding="inline"
          />
        )}{" "}
        <span>
          {label?.localized}
          {showDescription && content?.localized ? (
            <span className={styles.description}>
              <br />
              {content?.localized}
            </span>
          ) : null}
        </span>
      </div>
    </div>
  );
};

export default ExcursionAccessibilityLevel;
